import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-performance-audit-display-not-applicable',
    standalone: false,
    template: `
        <mon-markdown-viewer [monMarkdown]="audit.description"></mon-markdown-viewer>
    `,
})
export class PagePerformanceAuditDisplayNotApplicableComponent {
    @Input() audit: any;

    constructor () {}
}
